/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SessionKind,
  SessionKind$inboundSchema,
  SessionKind$outboundSchema,
} from "./sessionkind.js";

export type TerminateSessionRequest = {
  sessionId: string;
  sessionToken?: string | null | undefined;
  expectedSessionKind?: SessionKind | null | undefined;
};

/** @internal */
export const TerminateSessionRequest$inboundSchema: z.ZodType<
  TerminateSessionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  session_token: z.nullable(z.string()).optional(),
  expected_session_kind: z.nullable(SessionKind$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "session_token": "sessionToken",
    "expected_session_kind": "expectedSessionKind",
  });
});
/** @internal */
export type TerminateSessionRequest$Outbound = {
  session_id: string;
  session_token?: string | null | undefined;
  expected_session_kind?: string | null | undefined;
};

/** @internal */
export const TerminateSessionRequest$outboundSchema: z.ZodType<
  TerminateSessionRequest$Outbound,
  z.ZodTypeDef,
  TerminateSessionRequest
> = z.object({
  sessionId: z.string(),
  sessionToken: z.nullable(z.string()).optional(),
  expectedSessionKind: z.nullable(SessionKind$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    sessionToken: "session_token",
    expectedSessionKind: "expected_session_kind",
  });
});

export function terminateSessionRequestToJSON(
  terminateSessionRequest: TerminateSessionRequest,
): string {
  return JSON.stringify(
    TerminateSessionRequest$outboundSchema.parse(terminateSessionRequest),
  );
}
export function terminateSessionRequestFromJSON(
  jsonString: string,
): SafeParseResult<TerminateSessionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TerminateSessionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TerminateSessionRequest' from JSON`,
  );
}
